import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=70312d9d&scoped=true"
import script from "./WalletList.vue?vue&type=script&lang=js"
export * from "./WalletList.vue?vue&type=script&lang=js"
import style0 from "./WalletList.vue?vue&type=style&index=0&id=70312d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70312d9d",
  null
  
)

export default component.exports